'use strict';
/**
 *  Module  退稿模板
 *  createBy  CC
 *  reconstructedBy  He.zhikai  2017-1-19
 * Description  2016-1-12
 */
angular.module('editNewspaperRejectionModule', []).controller('editNewspaperRejectionCtrl', [
    '$scope',
    '$q',
    '$modalInstance',
    '$timeout',
    '$filter',
    'initSingleSelecet',
    'trsHttpService',
    'modalDialog',
    'params',
    'editingCenterService',
    'trsspliceString',
    'globleParamsSet',
    '$sessionStorage',
    function(
        $scope,
        $q,
        $modalInstance,
        $timeout,
        $filter,
        initSingleSelecet,
        trsHttpService,
        modalDialog,
        params,
        editingCenterService,
        trsspliceString,
        globleParamsSet,
        $sessionStorage,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.params = {
                serviceid: 'mlf_paper',
                PaperId: params.PaperId,
            };
            $scope.status = {
                // eslint-disable-next-line no-unneeded-ternary
                isDepartMent: params.isDepartMent ? true : false,
                selectedUser: '', // 退稿人
                isManusCorrShow: false, // 显示关联稿件
                hasNoManusCorr: false, // 无关联稿件
                currItem: '', // 当前选中的稿件
                currItemId: '', // 当前选中稿件的 METADATAID
                currItemOriginId: '', // 当前选中稿件的 ORIGINMETADATAID
                selectedType: '0', // 退稿类型
                treeOptions: editingCenterService.channelTreeOptions(),
                draftFrom: {
                    29: '归档稿',
                    30: '今日稿',
                    31: '待用稿',
                    32: '今日稿',
                    33: '今日稿',
                    34: '上版稿',
                    35: '已签稿',
                    36: '已签稿',
                    37: '已签稿',
                    38: '已签稿',
                },
                isRequest: false,
            };
            $scope.data = {
                items: angular.copy(params.item),
                opinion: '',
                rejectionTypes: initSingleSelecet.radioOfRejection(), //退稿单选框
                selectedDraftArray: [], // 已选的关联稿件
                draftExceptSignedNum: [], // 除已签稿以外的关联稿件数量
                selectedRelatedDraft: [],
            };
            $scope.item = [];
            getFlexContentH();
        }

        /**
         * [handleTitle description] 处理标题
         * @param {object} [item] [description] 列表数据
         * @return {[type]} [description]
         */
        $scope.handleTitle = function(item) {
            item.TITLE = $('<div>' + item.TITLE + '</div>').text();
        };

        $scope.searchUser = function(){
            var params = {
                serviceid: 'mlf_group',
                methodname: 'getUsersByGroup',
                GroupId: 5,
                searchword: $scope.searchword
            };
            requestData(params).then(function(data) {
                if (data.status !== undefined && data.status == '-1') {
                    modalDialog.alertType('', '获取用户失败', 'error', false, function() {
                    });
                } else {
                    $scope.users = data;
                    angular.forEach($scope.users, function(data, index, array) {
                        $scope.users[index].GROUPID = node.GROUPID;
                    });
                }
            });
        }

        /**
         * [getFlexContentH description]
         *
         * @return  {[type]}  [return description]
         */
        function getFlexContentH() {
            $timeout(function() {
                var height = document.getElementsByClassName('newspaper_rejection_left')[0].offsetHeight;
                document.getElementsByClassName('flexContent')[0].style.height = height + 'px';
            }, 500);
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.data.items.length > 1) {
                $scope.status.selectedType = '2';
            }
            // 部门稿库 退稿多篇的话 只能退回到其他人
            if (params.isDepartMent && $scope.data.items.length > 1) {
                $scope.status.selectedType = '1';
            }
            getHandlers();
        }

        /**
         * [getHandlers description]根据退稿类型获取退稿人数据
         * @return {[type]} [description]
         */
        function getHandlers() {
            if ($scope.status.selectedType == 1) {
                getMediaAndPerson();
            }
            if ($scope.status.selectedType == 0) {
                var editParams = {
                    serviceid: 'mlf_paper',
                    methodname: 'queryEditFlowGroupPath',
                    MetaDataId: $scope.data.items[0].METADATAID,
                };
                // 部门稿库查询经手人接口
                var departRejectParams = {
                    serviceid: 'mlf_appfgd',
                    methodname: 'queryEditFlowGroupPath',
                    MetaViewDataId: $scope.data.items[0].METADATAID,
                };
                let requestParams = params.isDepartMent ? departRejectParams : editParams;
                requestData(requestParams).then(function(data) {
                    $scope.editInfos = data;
                    // 退回经手人 只有一条数据的时候才给默认值
                    if (data.length === 1) {
                        $scope.status.selectedUser = data[0];
                    }
                });
            }
        }

        /**
         * [getMediaAndPerson description]获得媒体跟人员列表
         * @return {[type]} [description]
         */
        function getMediaAndPerson() {
            var params = {
                serviceid: 'mlf_group',
                methodName: 'queryGroupTreeWithMyPath',
            };
            requestData(params).then(function(data) {
                $scope.treedata = [data];
                expandedNodes();
            });
        }

        /**
         * [requestData description]数据请求函数
         * @param  {[obj]} params [description]请求参数
         * @return {[obj]}        [description]请求返回值
         */
        function requestData(params) {
            var deffered = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                deffered.resolve(data);
            });
            return deffered.promise;
        }

        /**
         * [ManusCorrToggle description]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.ManusCorrToggle = function(item) {
            if ($scope.status.currItemId == '' || $scope.status.currItemId != item.METADATAID) {
                $scope.data.selectedDraftArray = [];
                $scope.status.currItem = item;
                $scope.status.currItemId = item.METADATAID;
                $scope.status.currItemOriginId = item.ORIGINMETADATAID;
                if ($scope.data.selectedDraftArray[$scope.status.currItemOriginId] == undefined) {
                    var tempArray = [];
                    for (var i = 0; i < $scope.data.items.length; i++) {
                        if ($scope.data.items[i].ORIGINMETADATAID == $scope.status.currItemOriginId) {
                            tempArray.push($scope.data.items[i]);
                        }
                    }
                    $scope.data.selectedDraftArray[$scope.status.currItemOriginId] = [].concat(tempArray);
                }
                $scope.status.isManusCorrShow = true;
                $scope.params.SrcDocId = item.METADATAID;
                manuscriptCorrelationData(item);
            } else if ($scope.status.currItemId == item.METADATAID) {
                $scope.status.currItemId = '';
                $scope.status.currItemOriginId = '';
                $scope.status.isManusCorrShow = false;
            }
        };

        /**
         * [manuscriptCorrelationData description]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function manuscriptCorrelationData(item) {
            var methodnameObj = {
                29: 'queryReleteDocsInGuiDang',
                30: 'queryRelateDocsInJinRi',
                31: 'queryRelateDocsInDaiYong',
                32: 'queryRelateDocsInJinRi',
                33: 'queryRelateDocsInJinRi',
                34: 'queryRelateDocsInShangBan',
                35: 'queryReleteDocsInYiQianFa',
                36: 'queryReleteDocsInYiQianFa',
                37: 'queryReleteDocsInYiQianFa',
                38: 'queryReleteDocsInYiQianFa',
            };
            $scope.params.methodname = methodnameObj[item.DOCSTATUS];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                var signedDraftNum = 0;
                //排除已签稿
                angular.forEach(data, function(value, index) {
                    value.ORIGINMETADATAID = item.ORIGINMETADATAID;
                    if (parseInt(value.DOCSTATUS) >= 35) {
                        signedDraftNum++;
                    }
                });
                $scope.data.relationDraft = data;
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < data.length; i++) {
                    for (var j in $scope.data.items) {
                        if ($scope.data.items[j].RECID === data[i].RECID) {
                            $scope.data.selectedRelatedDraft.push(data[i]);
                        }
                    }
                }
                $scope.data.draftExceptSignedNum[item.ORIGINMETADATAID] = data.length - signedDraftNum;
                $scope.status.hasNoManusCorr = data == '' ? true : false;
            });
        }

        /**
         * [indexOf description]自制indexOf，根据数组中唯一值去重
         * @param  {[type]} array [description]去重的数组
         * @param  {[type]} item  [description]单独值
         * @return {[type]}       [description]
         */
        function indexOf(array, item) {
            for (var i = 0; i <= array.length; i++) {
                if (angular.isDefined(array[i])) {
                    if (array[i].METADATAID == item.METADATAID) {
                        return i;
                    }
                }
            }
        }

        /** [chooseAllRelateDraft description]全选或者取消全选的操作 */
        $scope.chooseAllRelateDraft = function() {
            if ($scope.data.selectedRelatedDraft.length === $scope.data.relationDraft.length && $scope.data.relationDraft.length > 0) {
                $scope.data.selectedRelatedDraft = [];
                for (var i = 0; i < $scope.data.relationDraft.length; i++) {
                    for (var x in $scope.data.items) {
                        if ($scope.data.items[x].RECID === $scope.data.relationDraft[i].RECID) {
                            $scope.data.items.splice(x, 1);
                            break;
                        }
                    }
                }
            } else {
                $scope.data.selectedRelatedDraft = [];
                for (var j = 0; j < $scope.data.relationDraft.length; j++) {
                    $scope.data.selectedRelatedDraft.push($scope.data.relationDraft[j]);
                    var flag = true;
                    for (var y in $scope.data.items) {
                        if ($scope.data.items[y].RECID === $scope.data.relationDraft[j].RECID) {
                            flag = false;
                        }
                    }
                    if (flag) {
                        $scope.data.items.push($scope.data.relationDraft[j]);
                    }
                }
            }
        };
        //选择相关联的稿件
        $scope.chooseRelatedDraft = function(item) {
            var num = $scope.data.selectedRelatedDraft.indexOf(item),
                flag = true,
                num2;
            if (num === -1) {
                $scope.data.selectedRelatedDraft.push(item);
            } else {
                $scope.data.selectedRelatedDraft.splice(num, 1);
            }
            for (var i = 0; i < $scope.data.items.length; i++) {
                if ($scope.data.items[i].RECID === item.RECID) {
                    flag = false; //遍历已有数组发现有该条数据时候标记为错误并退出循环 去删除该条数据
                    num2 = i;
                    break;
                } else {
                    //遍历完数组也未发现有该数据就将它压入列表展示数组
                    flag = true;
                }
            }
            $timeout(function() {
                if (flag) {
                    $scope.data.items.push(item);
                } else {
                    $scope.data.items.splice(num2, 1);
                }
            });
        };

        /**
         * [isSelected description] 关联稿件是否处于被选择状态
         * @param  {[type]}  array [description]
         * @param  {[type]}  item  [description]
         * @return {Boolean}       [description]
         */
        $scope.isSelected = function(array, item) {
            for (var i = 0; i <= array.length; i++) {
                if (angular.isDefined(array[i])) {
                    if (array[i].METADATAID == item.METADATAID) {
                        return true;
                    }
                }
            }
        };

        /**
         * [singleDel description] 删除已选稿件
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleDel = function(item) {
            if ($scope.status.currItemId == item.METADATAID) {
                $scope.status.currItemId = '';
                $scope.status.isManusCorrShow = false;
            }
            $scope.data.items.splice($scope.data.items.indexOf(item), 1);
            var index = $scope.data.selectedRelatedDraft.indexOf(item);
            $scope.data.selectedRelatedDraft.splice(index, 1);
        };

        /**
         * [selectrejectionType description] 选择退稿类型
         * @param  {[type]} rejectionType [description]
         * @return {[type]}               [description]
         */
        $scope.selectrejectionType = function(rejectionType) {
            $scope.status.selectedType = rejectionType;
            $scope.status.selectedUser = '';
            getHandlers();
        };

        /**
         * [getEditInfo description] 选中经手人信息
         * @param  {[type]} editInfo [description]
         * @return {[type]}          [description]
         */
        $scope.getEditInfo = function(editInfo) {
            $scope.status.selectedUser = editInfo;
        };

        /**
         * [expandedNodes description] 默认展开树开始
         * @return {[type]} [description]
         */
        function expandedNodes() {
            $scope.expandedTest = [];
            $scope.expandedTest.push($scope.treedata[0]);
            if ($scope.treedata[0].CHILDREN === 0) {
                $scope.selectedNode = $scope.treedata[0];
                getGroupData($scope.selectedNode);
            } else {
                angular.forEach($scope.treedata[0].CHILDREN, function(data, index, array) {
                    if (data.ISPATH === 'true') {
                        $scope.expandedTest.push(data);
                        if (data.CHILDREN.length !== 0) {
                            selfPath(data);
                        } else {
                            if (data.TENANTID === $sessionStorage.get('curUserInfo').TENANTID) {
                                $scope.selectedNode = data;
                                getGroupData($scope.selectedNode);
                            }
                        }
                    }
                });
            }
        }

        /**
         * [getGroupData description] 获取用户信息
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        function getGroupData(node,searchword) {
            var params = {
                serviceid: 'mlf_group',
                methodname: 'getUsersByGroup',
                GroupId: node.GROUPID,
                searchword: searchword
            };
            requestData(params).then(function(data) {
                if (data.status !== undefined && data.status == '-1') {
                    modalDialog.alertType('', '获取用户失败', 'error', false, function() {
                    });
                } else {
                    $scope.users = data;
                    angular.forEach($scope.users, function(data, index, array) {
                        $scope.users[index].GROUPID = node.GROUPID;
                    });
                }
            });
        }

        /**
         * [selfPath description] 获取路径
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function selfPath(data) {
            if (data.CHILDREN[0].ISPATH === 'true') {
                if (data.CHILDREN[0].HASCHILDREN === 'false' || data.CHILDREN[0].CHILDREN.length === 0 && data.TENANTID === $sessionStorage.get('curUserInfo').TENANTID) {
                    $scope.selectedNode = data.CHILDREN[0];
                    getGroupData($scope.selectedNode);
                } else {
                    $scope.expandedTest.push(data.CHILDREN[0]);
                    selfPath(data.CHILDREN[0]);
                }
            }
        }

        /**
         * [getSuggestions description]获取suggestion
         * @param  {[str]} viewValue [description]输入框内输入值
         * @return {[type]}           [description]
         */
        $scope.getSuggestions = function(viewValue) {
            var searchUsers = {
                serviceid: 'mlf_extuser',
                methodname: 'searchUser',
                Name: viewValue,
            };
            if (viewValue !== '') {
                if ($scope.isRequest) {
                    $scope.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, 'post').then(function(data) {
                        return data;
                    });
                }
            }
        };

        /**
         * [description]Suggestion 监听
         */
        $scope.$watch('searchWord', function(newValue, oldValue, scope) {
            if (angular.isObject(newValue)) {
                $scope.isRequest = true;
                $scope.users = [newValue];
                $scope.searchWord = newValue.USERNAME;
            }
        });

        /**
         * [showToggle description] 打开当前树节点的下级子组
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        $scope.showToggle = function(node) {
            childrenTree(node, function() {
            });
        };

        /**
         * [childrenTree description]获得下一级子组
         * @param  {[obj]}   node     [description]当前组信息
         * @param  {Function} callback [description]回调
         * @return {[type]}            [description]
         */
        function childrenTree(node, callback) {
            if (node.HASCHILDREN == 'true' && node.CHILDREN.length === 0) {
                var paramsT = {
                    serviceid: 'mlf_group',
                    methodname: 'queryChildGroupsWithOutRight',
                    GroupId: node.GROUPID,
                };
                trsHttpService.httpServer('/wcm/mlfcenter.do', paramsT, 'get').then(
                    function(dataC) {
                        node.CHILDREN = dataC.CHILDREN;
                        callback();
                    },
                    function(dataC) {
                        modalDialog.alertType('', '获取子组失败', 'error', false);
                    },
                );
            }
        }

        /**
         * [showSelected description] 选中当前树节点
         * @param  {[type]} node [description]
         * @return {[type]}      [description]
         */
        $scope.showSelected = function(node) {
            getGroupData(node,'');
            $scope.status.selectedUser = '';
        };

        /**
         * [userSelect description] 选中人员信息
         * @param  {[type]} user [description]
         * @return {[type]}      [description]
         */
        $scope.userSelect = function(user) {
            $scope.status.selectedUser = user;
        };

        /**
         * [confirm description] 确认退稿
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var message = errorMessage();
            if (message === '') {
                $scope.status.isManusCorrShow = false;
                var rejectionParams = {
                    serviceid: 'mlf_fusionpaper',
                    methodname: params.rejecectionMethod,
                    userId: $scope.status.selectedUser.ID,
                    GroupId: $scope.status.selectedUser.GROUPID,
                    RejectionType: $scope.status.selectedType,
                    option: $scope.data.opinion,
                    metaDataIds: trsspliceString.spliceString($scope.data.items, 'METADATAID', ','),
                };
                rejectionParams.SrcBanMianIds = angular.isDefined($scope.data.items[0].CHNLID)
                    ? trsspliceString.spliceString($scope.data.items, 'CHNLID', ',')
                    : trsspliceString.spliceString($scope.data.items, 'CHANNELID', ',');
                if (parseInt(rejectionParams.RejectionType) == 0) {
                    rejectionParams.RejectionType = parseInt(rejectionParams.RejectionType) + 1;
                }
                let departConfirmParams = {
                    serviceid: 'mlf_departoperdoc',
                    methodname: 'rejectedDepartDocs',
                    DepartdocrelIds: trsspliceString.spliceString($scope.data.items, 'DEPARTDOCRELID', ','),
                    opinion: $scope.data.opinion,
                    userid: $scope.status.selectedUser.ID,
                };
                let confirmParams = params.isDepartMent ? departConfirmParams : rejectionParams;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), confirmParams, 'get').then(
                    function(data) {
                        modalDialog.multiReportsAlert(data, function() {
                            $modalInstance.close('success');
                        });
                    },
                    function() {
                        $modalInstance.close();
                    },
                );
            }
        };

        /**
         * [errorMessage description]检测退稿时的操作错误并给出提示
         * @return {[str]} [description]返回提示语
         */
        function errorMessage() {
            var message = '';
            if ($scope.data.items.length === 0) {
                message = '稿件数量为零，请选择稿件后退稿';
            } else if ($scope.status.selectedType != '2' && $scope.status.selectedUser == '') {
                message = '请选择退回人';
            }
            if (message !== '') {
                modalDialog.alertType('', message, 'error', 'confirm');
            }
            return message;
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.close();
        };
    },
]);
